module.exports = __webpack_public_path__ + "img/link-examples.89c9b028.png";